var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmrPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 132,
    viewBox: "0 0 129 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F8F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21305_78232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5312 40.4502H54.8945C54.2109 38.6436 52.502 37.3252 50.5 37.3252C48.4492 37.3252 46.7402 38.6436 46.0566 40.4502H43.4688C42.1504 40.4502 41.125 41.5244 41.125 42.7939V59.9814C41.125 61.2998 42.1504 62.3252 43.4688 62.3252H57.5312C58.8008 62.3252 59.875 61.2998 59.875 59.9814V42.7939C59.875 41.5244 58.8008 40.4502 57.5312 40.4502ZM50.5 40.4502C51.3301 40.4502 52.0625 41.1826 52.0625 42.0127C52.0625 42.8916 51.3301 43.5752 50.5 43.5752C49.6211 43.5752 48.9375 42.8916 48.9375 42.0127C48.9375 41.1826 49.6211 40.4502 50.5 40.4502ZM55.1875 53.7314C55.1875 54.1709 54.7969 54.5127 54.4062 54.5127H52.0625V56.8564C52.0625 57.2959 51.6719 57.6377 51.2812 57.6377H49.7188C49.2793 57.6377 48.9375 57.2959 48.9375 56.8564V54.5127H46.5938C46.1543 54.5127 45.8125 54.1709 45.8125 53.7314V52.1689C45.8125 51.7783 46.1543 51.3877 46.5938 51.3877H48.9375V49.0439C48.9375 48.6533 49.2793 48.2627 49.7188 48.2627H51.2812C51.6719 48.2627 52.0625 48.6533 52.0625 49.0439V51.3877H54.4062C54.7969 51.3877 55.1875 51.7783 55.1875 52.1689V53.7314Z",
    fill: "#A0438B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21305_78232",
    x: -27.625,
    y: -31.4248,
    width: 156.25,
    height: 162.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21305_78232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21305_78232",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmrPink);
export default __webpack_public_path__ + "static/media/emr-pink.def08e7e.svg";
export { ForwardRef as ReactComponent };